module.exports = __webpack_public_path__ + "static/media/checkbox-checked.0b86a5ad.svg";